import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {getRandomColor} from "../utils/GetRandomColor";
import {useNavigate} from "react-router-dom";

export default function LinkedText({ icon, text, to, href, customBgColor }) {
    const navigate = useNavigate();

    const handleClick = () => {
        if (to) {
            navigate(to);
        } else if (href) {
            window.open(href, '_blank', 'noopener,noreferrer');
        }
    };
    
    const styles = {
        color: '#ffffff',
        backgroundColor: !customBgColor ? getRandomColor() : customBgColor,
        textDecoration: 'none',
        marginBottom: '4px',
        padding: '2px',
        fontWeight: 'bolder',
        cursor: "pointer",
        display: 'inline-flex',
        alignItems: 'center',
        gap: icon ? '6px' : '0px',
    };

    return (
        <span onClick={handleClick} style={styles} rel="noopener noreferrer" target={"_blank"}>
            {icon && <FontAwesomeIcon icon={icon} />}
            {text}
        </span>
    );
}